import React, { useEffect } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import type { Address } from '../../types/customers';

interface AddressEditModalProps {
  open: boolean;
  address?: Address;
  onSave: (address: Address) => void;
  onCancel: () => void;
  t: any;
}

const ADDRESS_TYPE_OPTIONS = [
  { value: 'Property', label: 'Property Address' },
  { value: 'Billing', label: 'Billing Address' },
  { value: 'Other', label: 'Other Address' },
];

const AddressEditModal: React.FC<AddressEditModalProps> = ({ open, address, onSave, onCancel, t }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      if (address) {
        form.setFieldsValue(address);
      } else {
        form.resetFields();
        form.setFieldsValue({ type: 'Property' });
      }
    }
  }, [open, address, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSave(values as Address);
    } catch (e) {
      // Validation failed
    }
  };

  return (
    <Modal
      title={address ? t('common:editAddress', 'Edit Address') : t('common:addAddress', 'Add Address')}
      open={open}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      okText={t('common:save', 'Save')}
      cancelText={t('common:cancel', 'Cancel')}
      destroyOnHidden
    >
      <Form form={form} layout="vertical" name="addressEditForm">
        <Form.Item
          name="type"
          label={t('common:type', 'Type')}
          rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
        >
          <Select>
            {ADDRESS_TYPE_OPTIONS.map(opt => (
              <Select.Option key={opt.value} value={opt.value}>{t('sales:customers.addressType.'+opt.value, opt.label)}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="address"
          label={t('common:address')}
          rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="city"
          label={t('common:city')}
          rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="pincode"
          label={t('common:pincode')}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="country"
          label={t('common:country')}
          rules={[{ required: true, message: t('common:validation.required', 'This field is required') }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddressEditModal; 